import { Auth, Public } from './Routes';
import { useRoutes } from 'raviger';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";
import useGlobal from 'store/store';
import TermsDialog from 'Components/Common/TermsDialog';
import { system } from "../api/client"
import useAuth0Feathers from 'hooks/useAuth0Feathers';

const Router = () => {
    const publicRoutes = useRoutes(Public)
    const protectedRoutes = useRoutes({ ...Auth, ...Public })
    const { t } = useTranslation()

    // Use Auth0 hook
    const { isLoggedIn, reAuthenticate, logOut } = useAuth0Feathers();
    const [isReady, setIsReady] = useState(false);

    const [accessibiltyTermsDialog, setAccessibiltyTermsDialog] = useGlobal(
        (state) => state.accessibiltyTermsDialog,
        (actions) => actions.setAccessibiltyTermsDialog
    );

    // Re-authenticate on mount
    useEffect(() => {
        const init = async () => {
            try {
                await reAuthenticate();
            } catch (error) {
                console.log('Not authenticated:', error.message);
            } finally {
                setIsReady(true);
            }
        };

        init();
    }, []);

    // Token expiry check
    const parseJwt = (token) => {
        try {
            return JSON.parse(window.atob(token.split(".")[1]));
        } catch (e) {
            return null;
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (system !== "dev") {
                const token = system === "prod"
                    ? localStorage.getItem(`zofim-parents-portal-token`)
                    : localStorage.getItem(`zofim-parents-portal-token-${system}`);

                if (token) {
                    const decodedJwt = parseJwt(token);
                    if (decodedJwt?.exp * 1000 < Date.now()) {
                        logOut();
                    }
                }
            }
        }, 3600000);

        return () => clearTimeout(timer);
    }, []);

    // Wait until auth check is complete
    if (!isReady) {
        return null; // Or a loading spinner
    }

    const routes = isLoggedIn ? protectedRoutes : publicRoutes;

    return (
        <>
            {routes}
            <TermsDialog
                openDialog={accessibiltyTermsDialog}
                setOpenDialog={setAccessibiltyTermsDialog}
                title={t("accessibiltyStatment")}
                src={process.env.REACT_APP_ACCESSIBILITY_STATEMENT_URL}
                exitButton={true}
            />
        </>
    );
}

export default Router;